import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await register(name, email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Account created");
            nav("/dashboard");
        } else {
            toast.error(res.error);
        }
    };

    return (
        <div className="mx-auto grid min-h-[calc(100vh-4rem)] max-w-7xl grid-cols-1 items-center gap-12 px-6 py-16 md:grid-cols-2">
            <div className="hidden md:block">
                <div className="overline mb-4 text-primary">Get started</div>
                <h1 className="font-display text-5xl font-semibold tracking-tight">Create your prep account.</h1>
                <p className="mt-4 max-w-md text-muted-foreground">Free tier includes sample questions. Upgrade for the full simulator, analytics and unlimited practice.</p>
            </div>
            <form onSubmit={submit} className="mx-auto w-full max-w-md border border-border bg-card p-8" data-testid="register-form">
                <h2 className="font-display text-2xl font-semibold">Create account</h2>
                <div className="mt-6 space-y-4">
                    <div>
                        <Label htmlFor="name">Name</Label>
                        <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" />
                    </div>
                    <div>
                        <Label htmlFor="email">Email</Label>
                        <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="register-email" />
                    </div>
                    <div>
                        <Label htmlFor="password">Password</Label>
                        <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="register-password" />
                    </div>
                    <Button type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground hover:bg-primary/90" data-testid="register-submit">
                        {loading ? "Creating…" : "Create account"}
                    </Button>
                </div>
                <p className="mt-6 text-sm text-muted-foreground">
                    Already registered? <Link to="/login" className="text-primary" data-testid="register-to-login">Sign in</Link>
                </p>
            </form>
        </div>
    );
}
